export abstract class AppMenuService {
  abstract toggle(): void;
}
